module.exports = "<div class=\"form-group\">    \n    <select class=\"form-control\" required id=\"field\" required [(ngModel)] = \"fieldSelect\" (change)=\"onSelected(fieldSelect)\" >\n      <option *ngFor=\"let field of fields\" [ngValue]=\"field.ID\" >{{field.DESCRIPCION}}</option>\n    </select>\n  </div>"


//////////////////
// WEBPACK FOOTER
// D:/TPL ILG/3PL_ILG/src/app/components/tipo-formula-cobro/tipo-formula-cobro.component.html
// module id = ../../../../../src/app/components/tipo-formula-cobro/tipo-formula-cobro.component.html
// module chunks = main